var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMixedChartLineAndArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 7.5,
    stroke: "var(--report-widget-icon-stroke-outer)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 28H23.8333H19.6444H11V23.7818L19.6444 18.7404L23.8333 21.2105L31 17V28Z",
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 14.4589L23.8333 18.647L19.6444 16.2105L11 21.2632V18.7818L19.6444 13.7404L23.8333 16.2105L31 12V14.4589Z",
    fill: "#F37321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixedChartLineAndArea);
export default __webpack_public_path__ + "static/media/mixed-chart-line-and-area.1107d7c5975debd3209170201949e07f.svg";
export { ForwardRef as ReactComponent };